import React from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const GenericDatePicker = ({
  label = "Select Date",
  value,
  onChange,
  required = false,
  error = false,
  helperText = "",
  sx = {},
  slotProps = {},
  outputFormat = "DD-MMM-YYYY",
  displayFormat = "DD-MMM-YYYY",
  returnDayjsObject = false,
  ...props
}) => {
  const dayjsValue = value 
    ? (dayjs.isDayjs(value) ? value : dayjs(value, outputFormat))
    : null;

  const handleChange = (newDate) => {
    if (returnDayjsObject) {
      onChange(newDate);
    } else {
      onChange(newDate ? newDate.format(outputFormat) : "");
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label={label}
        value={dayjsValue}
        onChange={handleChange}
        format={displayFormat}
        slotProps={{
          textField: {
            size: "small",
            margin: "dense",
            required,
            fullWidth: true,
            error,
            helperText,
            sx: {
              backgroundColor: "white",
              "& .MuiFormLabel-asterisk": { color: "red" },
              "& .MuiInputBase-input::placeholder": {
                
              },
              ...sx,
            },
            inputProps: {
              placeholder: "DD-MMM-YYYY",
            },
            ...slotProps.textField,
          },
          ...slotProps,
        }}
        {...props}
      />
    </LocalizationProvider>
  );
};

export default GenericDatePicker;